<template>
  <v-snackbar
    v-model="isVisible"
    :timeout="-1"
    location="top"
    color="primary"
    variant="flat"
  >
    <div class="d-flex align-center justify-space-between w-100">
      <span>{{ $t('pwa.open_in_app_message') }}</span>
      <v-btn
        variant="outlined"
        size="small"
        color="white"
        @click="dismiss"
      >
        {{ $t('pwa.open_in_app_button') }}
      </v-btn>
    </div>
  </v-snackbar>
</template>

<script>
const INSTALLED_FLAG_KEY = 'pwa_installed_ios';
const DISMISSED_AT_KEY = 'pwa_open_in_app_dismissed_at';
const DISMISS_COOLDOWN_MS = 24 * 60 * 60 * 1000;

export default {
  name: "IosOpenInAppBanner",
  data() {
    return {
      isVisible: false,
    };
  },
  created() {
    const isStandalone = window.navigator.standalone === true;

    if (isStandalone) {
      // Running as the installed home-screen app — remember this so that
      // next time the same origin loads inside Safari we know the app is there.
      localStorage.setItem(INSTALLED_FLAG_KEY, 'true');
      return;
    }

    if (!this.isIos() || localStorage.getItem(INSTALLED_FLAG_KEY) !== 'true') {
      return;
    }

    const dismissedAt = Number(localStorage.getItem(DISMISSED_AT_KEY));
    if (dismissedAt && Date.now() - dismissedAt < DISMISS_COOLDOWN_MS) {
      return;
    }

    this.isVisible = true;
  },
  methods: {
    isIos() {
      const ua = window.navigator.userAgent;
      const isIphoneOrIpod = /iPhone|iPod/.test(ua);
      // iPadOS 13+ reports as "Macintosh" but is touch-capable, unlike real Macs.
      const isIpad = /iPad/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      return isIphoneOrIpod || isIpad;
    },
    dismiss() {
      localStorage.setItem(DISMISSED_AT_KEY, String(Date.now()));
      this.isVisible = false;
    },
  },
};
</script>
